import React, { memo } from 'react'
import Container from '@mui/material/Container'
import Grid from '@mui/material/Grid2'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Image from 'next/legacy/image'

// Estilos
import sx from './styles'

const featuresData = [
  {
    id: 1,
    title: 'VELOCIDAD TOTAL',
    subtitle: '+370 compradores en 24 horas',
    icon: '/oneday_assets/oneday_icons/thunder.svg',
  },
  {
    id: 2,
    title: 'MÁXIMA SEGURIDAD',
    subtitle: 'Durante todo el proceso, pago 100% seguro',
    icon: '/oneday_assets/oneday_icons/segurity.svg',
  },
  {
    id: 3,
    title: 'MEJOR PRECIO',
    subtitle: 'Tu decides si lo vendes',
    icon: '/oneday_assets/oneday_icons/segurity.svg',
  },
]

const OneDayFeatures = () => {
  return (
    <Box
      component="section"
      sx={sx.container}
      id="OneDayFeatures"
    >
      <Container maxWidth="xl">
        <Grid
          container
          spacing={{ xs: 4, md: 2 }}
          justifyContent="center"
        >
          {featuresData.map((feature) => (
            <Grid
              key={`feature-${feature.id}`}
              size={{ xs: 12, sm: 6, md: 4 }}
            >
              <Box sx={sx.itemContainer}>
                {/* Contenedor del ícono */}
                <Box sx={sx.iconBox}>
                  <Image
                    src={feature.icon}
                    alt={feature.title}
                    width={32}
                    height={32}
                    layout="fixed"
                  />
                </Box>

                {/* Contenedor de Textos */}
                <Box sx={sx.textContainer}>
                  <Typography
                    component="h3"
                    variant="inherit" // <-- Añadido aquí
                    sx={sx.title}
                  >
                    {feature.title}
                  </Typography>
                  <Typography
                    component="p"
                    variant="inherit" // <-- Añadido aquí
                    sx={sx.subtitle}
                  >
                    {feature.subtitle}
                  </Typography>
                </Box>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  )
}

export default memo(OneDayFeatures)
